// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.missions-page {
  padding-top: 80px;
}

.missions-hero {
  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);
  position: relative;
  padding: 100px 0 120px;
  color: white;
  overflow: hidden;
}

.missions-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(46, 163, 212, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(15, 76, 129, 0.3) 0%, transparent 50%);
}

.missions-hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.missions-badge {
  display: inline-block;
  padding: 10px 24px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 24px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: white;
}

.missions-title {
  font-size: 64px;
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: -1.5px;
  color: white;
}

.missions-subtitle {
  font-size: 20px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto;
}

.missions-hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  z-index: 2;
  line-height: 0;
}

.missions-hero-wave svg {
  width: 100%;
  height: auto;
  display: block;
}

.missions-overview {
  padding: 80px 0;
  background: white;
}

.stats-grid-missions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  max-width: 900px;
  margin: 0 auto;
}

.stat-mission-card {
  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 100%);
  padding: 40px;
  border-radius: 24px;
  text-align: center;
  color: white;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 8px 32px rgba(15, 76, 129, 0.2);
}

.stat-mission-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(15, 76, 129, 0.3);
}

.stat-mission-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.stat-mission-number {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1;
  color: white;
}

.stat-mission-label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.missions-timeline {
  padding: 80px 0;
  background: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 64px;
  color: var(--dark-color);
}

.timeline {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}

.timeline-item {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 32px;
  margin-bottom: 48px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  border: 4px solid white;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  z-index: 1;
}

.timeline-line {
  width: 3px;
  flex: 1 1;
  background: linear-gradient(to bottom, #FFD700, transparent);
  margin-top: 8px;
}

.mission-card {
  background: white;
  padding: 32px;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.mission-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.mission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.mission-year {
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
}

.mission-status {
  padding: 6px 16px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mission-status.ongoing {
  background: #e3f2fd;
  color: #1565c0;
}

.mission-status.recurring {
  background: #fff3e0;
  color: #e65100;
}

.mission-location {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--dark-color);
}

.mission-stats {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
}

.mission-stat {
  font-size: 14px;
  color: var(--text-light);
}

.mission-stat strong {
  font-size: 20px;
  color: var(--primary-color);
  font-weight: 700;
  display: block;
  margin-bottom: 4px;
}

.mission-procedures {
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-color);
  margin-bottom: 12px;
}

.mission-impact {
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-light);
}

.missions-volunteer {
  padding: 80px 0;
  background: white;
}

.volunteer-card {
  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);
  padding: 64px;
  border-radius: 32px;
  text-align: center;
  color: white;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 16px 48px rgba(15, 76, 129, 0.3);
}

.volunteer-content h2 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 20px;
  color: white;
}

.volunteer-content p {
  font-size: 18px;
  line-height: 1.7;
  margin-bottom: 32px;
  color: rgba(255, 255, 255, 0.9);
}

.btn-volunteer {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 18px 40px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #0f4c81;
  font-size: 18px;
  font-weight: 700;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 8px 24px rgba(255, 215, 0, 0.3);
}

.btn-volunteer:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(255, 215, 0, 0.4);
}

@media (max-width: 968px) {
  .missions-title {
    font-size: 48px;
  }

  .missions-subtitle {
    font-size: 18px;
  }

  .stats-grid-missions {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .section-title {
    font-size: 36px;
  }

  .timeline-item {
    grid-template-columns: 40px 1fr;
    gap: 20px;
  }
}

@media (max-width: 640px) {
  .missions-hero {
    padding: 60px 0 80px;
  }

  .missions-title {
    font-size: 36px;
  }

  .missions-subtitle {
    font-size: 16px;
  }

  .mission-card {
    padding: 24px;
  }

  .mission-location {
    font-size: 22px;
  }

  .volunteer-card {
    padding: 40px 24px;
  }

  .volunteer-content h2 {
    font-size: 32px;
  }

  .volunteer-content p {
    font-size: 16px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Missions.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;4FAC0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,uBAAuB;EACvB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAO;EACP,4DAA4D;EAC5D,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,SAAS;EACX;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".missions-page {\n  padding-top: 80px;\n}\n\n.missions-hero {\n  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);\n  position: relative;\n  padding: 100px 0 120px;\n  color: white;\n  overflow: hidden;\n}\n\n.missions-hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 50%, rgba(46, 163, 212, 0.3) 0%, transparent 50%),\n              radial-gradient(circle at 80% 80%, rgba(15, 76, 129, 0.3) 0%, transparent 50%);\n}\n\n.missions-hero-content {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.missions-badge {\n  display: inline-block;\n  padding: 10px 24px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(20px);\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: white;\n}\n\n.missions-title {\n  font-size: 64px;\n  font-weight: 700;\n  margin-bottom: 24px;\n  letter-spacing: -1.5px;\n  color: white;\n}\n\n.missions-subtitle {\n  font-size: 20px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.missions-hero-wave {\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  line-height: 0;\n}\n\n.missions-hero-wave svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.missions-overview {\n  padding: 80px 0;\n  background: white;\n}\n\n.stats-grid-missions {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.stat-mission-card {\n  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 100%);\n  padding: 40px;\n  border-radius: 24px;\n  text-align: center;\n  color: white;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 8px 32px rgba(15, 76, 129, 0.2);\n}\n\n.stat-mission-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 16px 48px rgba(15, 76, 129, 0.3);\n}\n\n.stat-mission-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.stat-mission-number {\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  line-height: 1;\n  color: white;\n}\n\n.stat-mission-label {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 500;\n}\n\n.missions-timeline {\n  padding: 80px 0;\n  background: #f8f9fa;\n}\n\n.section-title {\n  text-align: center;\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 64px;\n  color: var(--dark-color);\n}\n\n.timeline {\n  max-width: 900px;\n  margin: 0 auto;\n  position: relative;\n}\n\n.timeline-item {\n  display: grid;\n  grid-template-columns: 60px 1fr;\n  gap: 32px;\n  margin-bottom: 48px;\n}\n\n.timeline-item:last-child {\n  margin-bottom: 0;\n}\n\n.timeline-marker {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.timeline-dot {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  border: 4px solid white;\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);\n  z-index: 1;\n}\n\n.timeline-line {\n  width: 3px;\n  flex: 1;\n  background: linear-gradient(to bottom, #FFD700, transparent);\n  margin-top: 8px;\n}\n\n.mission-card {\n  background: white;\n  padding: 32px;\n  border-radius: 20px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n}\n\n.mission-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n}\n\n.mission-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.mission-year {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n.mission-status {\n  padding: 6px 16px;\n  background: #e8f5e9;\n  color: #2e7d32;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.mission-status.ongoing {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.mission-status.recurring {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.mission-location {\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--dark-color);\n}\n\n.mission-stats {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.mission-stat {\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n.mission-stat strong {\n  font-size: 20px;\n  color: var(--primary-color);\n  font-weight: 700;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.mission-procedures {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--dark-color);\n  margin-bottom: 12px;\n}\n\n.mission-impact {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--text-light);\n}\n\n.missions-volunteer {\n  padding: 80px 0;\n  background: white;\n}\n\n.volunteer-card {\n  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);\n  padding: 64px;\n  border-radius: 32px;\n  text-align: center;\n  color: white;\n  max-width: 800px;\n  margin: 0 auto;\n  box-shadow: 0 16px 48px rgba(15, 76, 129, 0.3);\n}\n\n.volunteer-content h2 {\n  font-size: 42px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.volunteer-content p {\n  font-size: 18px;\n  line-height: 1.7;\n  margin-bottom: 32px;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.btn-volunteer {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 40px;\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  color: #0f4c81;\n  font-size: 18px;\n  font-weight: 700;\n  border-radius: 50px;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 8px 24px rgba(255, 215, 0, 0.3);\n}\n\n.btn-volunteer:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 32px rgba(255, 215, 0, 0.4);\n}\n\n@media (max-width: 968px) {\n  .missions-title {\n    font-size: 48px;\n  }\n\n  .missions-subtitle {\n    font-size: 18px;\n  }\n\n  .stats-grid-missions {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .section-title {\n    font-size: 36px;\n  }\n\n  .timeline-item {\n    grid-template-columns: 40px 1fr;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 640px) {\n  .missions-hero {\n    padding: 60px 0 80px;\n  }\n\n  .missions-title {\n    font-size: 36px;\n  }\n\n  .missions-subtitle {\n    font-size: 16px;\n  }\n\n  .mission-card {\n    padding: 24px;\n  }\n\n  .mission-location {\n    font-size: 22px;\n  }\n\n  .volunteer-card {\n    padding: 40px 24px;\n  }\n\n  .volunteer-content h2 {\n    font-size: 32px;\n  }\n\n  .volunteer-content p {\n    font-size: 16px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
